import { useTranslation } from 'react-i18next'

import useSessionUser from '@/modules/access/hooks/useSessionUser'
import { Accordion } from '@/modules/shared/components/accordion/Accordion'
import { PlusIcon } from '@/modules/shared/icons/PlusIcon'
import { PurchaserIcon } from '@/modules/shared/icons/PurchaserIcon'
import SideNavLink, { SideNavLinkItem } from '@/modules/shared/layouts/side-navigation/SideNavLink'
import { SideBarItem } from '@/modules/shared/layouts/side-navigation/purchaser-navigation/PurchaserNavigation'
import { Themes } from '@/modules/shared/types/Themes'

interface OrganisationsSideBarItemProps extends SideBarItem {
  organisationsRoutesMatch: boolean
}

export const OrganisationsSideBarItem = ({
  organisationsRoutesMatch,
  openAccordionKey,
  changeOpenAccordionKey,
  onCloseDrawer,
  sideBarIndexKey,
}: OrganisationsSideBarItemProps) => {
  const { t } = useTranslation()
  const { userPermissions } = useSessionUser()

  const getSideNavLinkItems = () => {
    const sideNavItems: SideNavLinkItem[] = []
    if (userPermissions?.CAN_MANAGE_ORGANISATIONS) {
      sideNavItems.push({
        key: t('general.newOrganisation', 'New Organisation'),
        target: '/organisations/create',
        icon: <PlusIcon className="size-6 text-gray-500" />,
      })
      sideNavItems.push({
        key: t('general.viewAll', 'View All'),
        target: '/organisations',
      })
    }
    return sideNavItems
  }

  return (
    <Accordion
      titlePrefixIcon={<PurchaserIcon className="size-7" />}
      title={t('general.organisations', 'Organisations')}
      activeColor={organisationsRoutesMatch ? Themes.Primary : undefined}
      defaultOpen={openAccordionKey === sideBarIndexKey}
      handleTriggerClick={() => changeOpenAccordionKey(sideBarIndexKey)}
      buttonClassName="min-h-11 px-3"
      keepActiveColor
    >
      <SideNavLink
        onCloseDrawer={() => onCloseDrawer()}
        testId="organisations-navigation"
        sideNavLinkItems={getSideNavLinkItems()}
      />
    </Accordion>
  )
}
